/* eslint-disable */
export default {
  schedule: '모임 예약',
  prompt: '계정 정보에 액세스할 수 있도록 RingCentral에 권한을 부여하세요.',
  saveAsDefault: '기본값으로 저장',
  launchMeeting: '모임 시작',
} as const;

// @key: @#@"schedule"@#@ @source: @#@"Schedule Meeting"@#@
// @key: @#@"prompt"@#@ @source: @#@"Please authorize RingCentral to access your account information."@#@
// @key: @#@"saveAsDefault"@#@ @source: @#@"Save as default"@#@
// @key: @#@"launchMeeting"@#@ @source: @#@"Launch Meeting"@#@
